"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _filesize = _interopRequireDefault(require("filesize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(Froala) {
  Froala.PLUGINS.mediaErrorsPlugin = function (editor) {
    var setErrorMessage = function setErrorMessage(type, message) {
      var popup = editor.popups.get("".concat(type, ".insert"));
      var layer = popup.find(".fr-".concat(type, "-progress-bar-layer"));
      layer.addClass('fr-error');
      layer.find('h3').text(message);
    };

    var maxSizeFor = function maxSizeFor(type) {
      var maxSize = R.prop(type, {
        'video': editor.opts.videoMaxSize,
        'image': editor.opts.imageMaxSize,
        'file': editor.opts.fileMaxSize
      });
      return (0, _filesize.default)(maxSize);
    };

    var filetypes = function filetypes(type) {
      return R.prop(type, {
        'image': editor.opts.imageAllowedTypes,
        'video': editor.opts.videoAllowedTypes,
        'file': editor.opts.fileAllowedTypes
      }).join(', ');
    };

    var messageFor = function messageFor(type, error) {
      var message = R.prop(error.code, {
        5: "File is too large. Max size is ".concat(maxSizeFor(type)),
        6: "Invalid file type. Supported types: ".concat(filetypes(type))
      });
      return message || error.message;
    };

    var _init = function _init() {
      editor.events.on('video.error', function (error) {
        setErrorMessage('video', messageFor('video', error));
      });
      editor.events.on('image.error', function (error) {
        setErrorMessage('image', messageFor('image', error));
      });
      editor.events.on('file.error', function (error) {
        setErrorMessage('file', messageFor('file', error));
      });
    };

    return {
      _init: _init
    };
  };
};

exports.default = _default;